export var MooringSideContents;
(function (MooringSideContents) {
    MooringSideContents["Port"] = "port";
    MooringSideContents["Starboard"] = "starboard";
})(MooringSideContents || (MooringSideContents = {}));
export var MooringMarkContents;
(function (MooringMarkContents) {
    MooringMarkContents["BREAKWATER"] = "breakwater";
    MooringMarkContents["BUOY"] = "buoy";
    MooringMarkContents["LEADING_LIGHTS"] = "leading lights";
})(MooringMarkContents || (MooringMarkContents = {}));
export const mooringMarkContentOptions = [
    { value: MooringMarkContents.BREAKWATER, text: 'breakwater' },
    { value: MooringMarkContents.BUOY, text: 'buoy' },
    { value: MooringMarkContents.LEADING_LIGHTS, text: 'leading lights' },
];
//# sourceMappingURL=MooringPassingMarkContents.js.map